import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
  })
export class JourneyService {

    constructor(@Inject(Router) public router: Router){}

    private _currentStep:string;
    private _previousStep:string;

    /**
     * Returns the name of current Step
     */
    get currentStep(){
        return this._currentStep;
    }

    /**
     * Returns the name of previous step
     */
    get previousStep(){
        return this._previousStep;
    }

    next(name:string){
        // this._currentStep;
        //this.router.navigate([name]);
    }

    previous(name:string){
        // this._currentStep;
        //this.router.navigate([name]);
    }
}
